module.exports = __webpack_public_path__ + "fonts/bfd447e33f67aa191efb2378f47d7c64.svg";